import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export const SyncingState = () => {
  const { t } = useTranslation(['authenticated.settings']);

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-medium">
            {t('authenticated.settings:pages.integrations.refreshCard.syncing.title')}
          </h3>
          <div className="inline-flex items-center rounded-full border border-chart-3 bg-background px-2.5 py-0.5 text-xs font-semibold text-chart-3 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            {t('authenticated.settings:pages.integrations.refreshCard.syncing.badge')}
          </div>
        </div>
        <p className="text-xs text-foreground">
          {t('authenticated.settings:pages.integrations.refreshCard.syncing.subtitle')}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" variant="default" disabled>
          <Loader2 className="h-4 w-4 animate-spin" />
          {t('authenticated.settings:pages.integrations.refreshCard.syncing.action')}
        </Button>
      </div>
    </div>
  );
};
